import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeButton } from '@shared/ui/buttons';
import FormGroup from '@shared/ui/forms/display/FormGroup';
import { CounterTag } from '@shared/ui/parts';
import { useCreateTeamDialog } from '@utils/dialogs-hooks';
import { theme } from '@utils/libs/theme';

const MAX_LEAD_TEAMS = 5;

export default function MemberTeams({ data, hideCreateBtn = false }) {
  const { t } = useTranslation();
  const { openCreateTeamDialog } = useCreateTeamDialog();
  const { user } = useSelector((state) => state.user);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <FormGroup label={t('teams')}>
      <div className="member-teams">
        {!user?.group_role &&
          !hideCreateBtn &&
          !isMobile &&
          data?.groups?.length < MAX_LEAD_TEAMS && (
            <ThemeButton
              block={false}
              appearance="secondary"
              startIcon="add"
              onClick={() =>
                openCreateTeamDialog({ teamLead: { id: data?.id } })
              }
            >
              {t('create_new')}
            </ThemeButton>
          )}
        {data?.groups?.map((group) => (
          <CounterTag key={group.id} data={group} />
        ))}
      </div>
    </FormGroup>
  );
}
